<div class="kt-subheader__breadcrumbs"
    *ngIf="roleMatrix.role === 'SUPERADMIN' || roleMatrix.role === 'ADMIN' || roleMatrix.role === 'USER'">
    <a [routerLink]="['/']" class="kt-subheader__breadcrumbs-home">
        <em class="flaticon2-shelter"></em>
    </a>
    <span class="kt-subheader__breadcrumbs-separator"></span>
    <a [routerLink]="['/company/manage']" class="kt-subheader__breadcrumbs-link">
        Companies </a>
    <span class="kt-subheader__breadcrumbs-separator"></span>
    <a [routerLink]="['/company/detail',companyId]" class="kt-subheader__breadcrumbs-link">
        Company Details </a>
    <span class="kt-subheader__breadcrumbs-separator"></span>
    <a [routerLink]="['/work-order/manage',companyId]" class="kt-subheader__breadcrumbs-link">
        Work Orders </a>
    <span class="kt-subheader__breadcrumbs-separator"></span>
    <a [routerLink]="['/work-order/detail',1, companyId, workOrderId]" class="kt-subheader__breadcrumbs-link">
        Work Order Details </a>
    <span class="kt-subheader__breadcrumbs-separator"></span>
    <span>Report Issue</span>
</div>
<div class="kt-subheader__breadcrumbs"
    *ngIf="roleMatrix.role === 'ORGSUPERADMIN' || roleMatrix.role === 'ORGADMIN' || roleMatrix.role === 'ORGUSER'">
    <a [routerLink]="['/']" class="kt-subheader__breadcrumbs-home">
        <em class="flaticon2-shelter"></em>
    </a>
    <span class="kt-subheader__breadcrumbs-separator"></span>
    <a [routerLink]="['/work-order/manage',companyId]" class="kt-subheader__breadcrumbs-link">
        Work Orders </a>
    <span class="kt-subheader__breadcrumbs-separator"></span>
    <a [routerLink]="['/work-order/detail',1, companyId, workOrderId]" class="kt-subheader__breadcrumbs-link">
        Work Order Details </a>
    <span class="kt-subheader__breadcrumbs-separator"></span>
    <span>Report Issue</span>
</div>